import { useMemo } from 'react';
import { useMusic24Capabilities } from '../../hooks/useMusic24Capabilities';
import { SMLNavItem, visibleNavigationItems } from '../smlNavigation';

/** Every destination in navigation order, without the items the plan of the active workspace hides. */
export function useVisibleNavigationItems(): SMLNavItem[] {
  const { canUseAiReels } = useMusic24Capabilities();
  return useMemo(() => visibleNavigationItems({ canUseAiReels }), [canUseAiReels]);
}
